import { type GetSearchExamQSetUsageRecordsQuery } from '@report/graphql';

type QSetUsageReportItemData =
  GetSearchExamQSetUsageRecordsQuery['reportSearchExamQSetUsageRecords']['records'][number];

export function mapQSetUsageReportItem(item: QSetUsageReportItemData) {
  return {
    id: `${item.examCourseCode}-${item.qSetCode}-${item.qConfigRef}}`,
    examCourseCode: item.examCourseCode,
    qSetId: item.qSetCode,
    qConfigRefId: String(item.qConfigRef),
    startDate: item.startedAt,
    endDate: item.endedAt,
    pValueAvg: item.pAverage,
    examineeCount: item.examineeCount,
    passedExamineeCount: item.passedExamineeCount,
    passedRate: item.passedRate,
    maxScore: item.maxScore,
    minScore: item.minScore,
    avgScore: item.averageScore,
    sdScore: item.standardDeviationScore,
  };
}
